import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '@bcef/ia-components/header';
import { TranslatePipe } from '@ngx-translate/core';

import { BaseLayoutComponent } from './layout-base.component';

@Component({
  selector: 'ia-report-technical-problem-slim-layout',
  imports: [HeaderComponent, TranslatePipe, RouterOutlet],
  template: `
    <ia-header [title]="'header.title' | translate" [class]="headerClassAttributes" />
    <div
      class="tw-flex tw-flex-col mb-group:tw-mb-12 mb-group:tw-mt-10 mb-group:max-sm:tw-mt-5 md:mb-group:tw-mx-25"
    >
      <router-outlet />
    </div>
  `,
})
export class SlimLayoutComponent extends BaseLayoutComponent {}
